import { audioContext } from './context';

export const FFT_SIZE = 1024;

/**
 * Taps the synth's output for the on-screen waveform.
 *
 * The analyser needs a path to the destination to be pulled by the graph, but
 * the tap must be silent, so it runs through a zeroed gain node.
 */
export const analyser = audioContext.createAnalyser();
analyser.fftSize = FFT_SIZE;
analyser.smoothingTimeConstant = 0.6;

const silentTap = audioContext.createGain();
silentTap.gain.value = 0;
analyser.connect(silentTap);
silentTap.connect(audioContext.destination);

/** Reused every frame — never reallocate this in the render loop. */
export const waveformData: Float32Array<ArrayBuffer> = new Float32Array(analyser.fftSize);

const NORMALISE_FLOOR = 0.05;
const NORMALISE_RANGE = 0.8;

/**
 * Reads the current time-domain buffer and rescales it to roughly -0.8..0.8 so
 * quiet passages stay legible on the display. Writes into `target` in place.
 */
export function readNormalisedWaveform(
  target: Float32Array<ArrayBuffer> = waveformData,
): Float32Array<ArrayBuffer> {
  analyser.getFloatTimeDomainData(target);

  let min = -NORMALISE_FLOOR;
  let max = NORMALISE_FLOOR;
  for (let i = 0; i < target.length; i++) {
    const value = target[i];
    if (value > max) max = value;
    if (value < min) min = value;
  }

  const scale = (2 * NORMALISE_RANGE) / (max - min);
  for (let i = 0; i < target.length; i++) {
    target[i] = -NORMALISE_RANGE + (target[i] - min) * scale;
  }
  return target;
}
